var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('iframe',{ref:"popup",staticStyle:{"height":"100vh","width":"100vw"},attrs:{"src":_vm.$options.src,"title":"Simulator"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }